import React, { createContext, useContext } from 'react';
import countries from 'i18n-iso-countries';
import locales from '../I18n/locales.json';
locales.forEach(({
  id
}) => {
  countries.registerLocale(require(`i18n-iso-countries/langs/${id}.json`));
});
export const GlobalContext = /*#__PURE__*/createContext();
export const GlobalProvider = props => {
  const {
    actions,
    children = [],
    ...globalProps
  } = props;
  return /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: { ...globalProps,
      ...actions,
      countries
    }
  }, children || []);
};
export const useGlobalValue = () => useContext(GlobalContext) || {};